<template>
    <div>
        <div v-if="all>0" class="pageAssembly clearfix">
            <el-pagination layout="slot" :page-size.sync="pagesize" :current-page.sync="currentpage" :page-count.sync="lastpage" :total.sync="total">
                <div @click="firstPage" :class="['first',currentpage==1||!flag?'':'firstChecked']"></div>
            </el-pagination>
            <el-pagination layout="slot" :page-size.sync="pagesize" :current-page.sync="currentpage" :page-count.sync="lastpage" :total.sync="total">
                <div @click="prev" :class="['prev',currentpage==1||!flag?'':'canClick']"><i class="el-icon el-icon-arrow-left"></i></div>
            </el-pagination>
            <el-pagination layout="pager" :disabled="!flag" @current-change="changePage" :page-size.sync="pagesize" :current-page.sync="currentpage" :page-count.sync="lastpage" :total.sync="total">
            </el-pagination>
            <el-pagination layout="slot" :page-size.sync="pagesize" :current-page.sync="currentpage" :page-count.sync="lastpage" :total.sync="total">
                <div @click="next" :class="['next',currentpage==lastpage||!flag?'':'canClick']"><i class="el-icon el-icon-arrow-right"></i></div>
            </el-pagination>
            <el-pagination layout="slot" :page-size.sync="pagesize" :current-page.sync="currentpage" :page-count.sync="lastpage" :total.sync="total">
                <div @click="last" :class="['last',currentpage==lastpage||!flag?'':'lastChecked']"></div>
            </el-pagination>
            <el-pagination layout="total" :page-size.sync="pagesize" :current-page.sync="currentpage" :page-count.sync="lastpage" :total.sync="total">
            </el-pagination>
            <el-select v-model="pagesize" class="pageSize" @change="sizeChange" placeholder="">
                <el-option :label="20" :value="20"></el-option>
                <el-option :label="50" :value="50"></el-option>
                <el-option :label="80" :value="80"></el-option>
                <el-option :label="100" :value="100"></el-option>
                <el-option :label="150" :value="150"></el-option>
            </el-select>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            lastpages:{
                type:Number,
                default:1
            },
            currentpages:{
                type:Number,
                default:1
            },
            all:{
                type:Number,
                default:1
            },
            pagesizes:{
                type:Number,
                default:50
            }
        },
        data(){
            return { 
                lastpage:this.lastpages,
                currentpage:this.currentpages,
                total:this.all,
                pagesize:this.pagesizes,
                flag:true
            }
        },
        watch:{
            lastpages(val){
                this.lastpage=val;
            },
            currentpages(val){
                this.currentpage=val;
            },
            all(val){
                this.total=val;
            },
            pagesizes(val){
                this.pagesize=val;
            }
        },
        created(){
        },
        methods:{
            changePage(r){
                this.flag = false;
                this.push(r)
            },
            prev(){
                 if(this.currentpage>1&&this.flag){
                    --this.currentpage;
                    this.push(this.currentpage)
                    this.flag = false;
                }else{
                    return false;
                }
            },
            next(){
                if(this.currentpage<this.lastpage&&this.flag){
                    ++this.currentpage;
                    this.push(this.currentpage)
                    this.flag = false;
                }else{
                    return false;
                }
            },
            firstPage(){
                if(this.currentpage>1&&this.flag){
                    this.push(1)
                    this.flag = false;
                }
            },
            last(){
                if(this.currentpage<this.lastpage&&this.flag){
                    this.push(this.lastpage)
                    this.flag = false;
                }
            },
            sizeChange(){
                this.push(1)
            },
            push(page){
                let obj = new Object();
                obj.currentpage=page;
                obj.pagesize=this.pagesize;
                this.$emit("getPage",obj)
            }
        }
    }
</script>
<style scoped>

</style>